var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.99999H14.95C14.7108 6.83679 13.6875 6.0015 12.5 6H11.5C10.3124 6.0015 9.28919 6.83679 9.04998 7.99999H7.49999C7.22385 7.99999 7 8.22384 7 8.49998C7 8.77612 7.22385 9 7.49999 9H7.99998V15.5C8.00165 16.88 9.11997 17.9984 10.5 18H13.5C14.88 17.9984 15.9983 16.88 16 15.5V9H16.5C16.7761 9 17 8.77615 17 8.50001C17 8.22387 16.7761 7.99999 16.5 7.99999ZM11.5 14.5C11.5 14.7761 11.2761 15 11 15C10.7238 15 10.5 14.7761 10.5 14.5V11.5C10.5 11.2239 10.7238 11 11 11C11.2761 11 11.5 11.2239 11.5 11.5V14.5H11.5ZM13.5 14.5C13.5 14.7761 13.2761 15 13 15C12.7239 15 12.5 14.7761 12.5 14.5V11.5C12.5 11.2239 12.7239 11 13 11C13.2761 11 13.5 11.2239 13.5 11.5V14.5ZM10.0855 7.99999C10.2982 7.40114 10.8645 7.00076 11.5 6.99998H12.5C13.1355 7.00076 13.7018 7.40114 13.9145 7.99999H10.0855Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.49068b274163e75298781f5b8f6fd656.svg";
export { ForwardRef as ReactComponent };